import { ControlChange } from '@/gen/inventory/v1/control_service_pb'

import { controlStatusLabel } from '@/const/label'

import { ControlStatusBadge } from '@/components/shared/control-status-badge/control-status-badge'
import { ChangeCard } from '@/components/timeline/change-card'

type ControlChangeCardProps = {
  change: ControlChange
}

export const ControlChangeCard = ({ change }: ControlChangeCardProps) => {
  const { prevStatus, newStatus, comment } = change

  const statement = `Changed control's validation status to '${controlStatusLabel[newStatus]}'`
  const prevBadge = <ControlStatusBadge status={prevStatus} variant='outline' />
  const newBadge = <ControlStatusBadge status={newStatus} variant='outline' />

  return (
    <ChangeCard statement={statement} prevBadge={prevBadge} newBadge={newBadge} comment={comment} />
  )
}
